<template>
  <div class="customer-location">
    <div class="container">
      <div class="searchClass">
        <van-search v-model="search" id="pickerInput" placeholder="请输入客户位置" style="flex: 1;" />
        <van-button type="info" size="small" style="margin-right: 12px; padding: 0 10px;" @click="searchEvent">搜 索</van-button>
      </div>
      <div id="map" />
    </div>
    <div class="customer-list border-top" style="--borderColor: #969799">
      <template v-if="customerList.length">
        <div class="list">
          <p v-for="item in customerList" :key="item.id" class="border-bottom">
            <span>
              <i>{{ item.distance | convertMilesToKm }}</i>
              <i>{{ item.customer.customerName }}</i>
            </span>
            <span>{{ item.project ? (item.project.name || '--') : '--' }}</span>
          </p>
        </div>
        <div class="page">
          <Pagination v-if="totalPage > 1" :totalCount="totalCount" :currentPage.sync="query.page" :currentCount="query.count" />
        </div>
      </template>
      <span v-else class="no-customer">附近暂无客户</span>
    </div>
  </div>
</template>

<script>
// import wx from "weixin-js-sdk";
import { getNearList } from "@/api/customer";
import { getlatandlngbyaddress } from '@/api/common'
import { loadMap } from '@/utils';
import Pagination from '@/components/pagination';
export default {
  name: "CustomerLocation",
  components: { Pagination },
  data() {
    return {
      search: "",
      popupVisible: false,
      columns: [],
      customerList: [],
      query: {
        page: 1,
        count: 10,
        citycode: "0755",
        lat: "113.90143",
        lng: "22.55734",
      },
      mapInstance: null,
      geocoder: null,
      geolocation: null,
      totalCount: 0,
      totalPage: 0
    };
  },
  watch: {
    query: {
      handler(newVal) {
        this.getCustomerList(newVal)
      },
      deep: true
    }
  },
  created() {
    // this.getLoaction()
    //   .then((res) => {
    //     const { longitude, latitude } = res
    //     this.$nextTick(() => {
    //       this.initMap([longitude, latitude])
    //       if (window.AMapUI) {
    //         this.initMapUI()
    //       } else {
    //         setTimeout(() => {
    //           this.initMapUI()
    //         }, 1500)
    //       }
    //     })
    //   })
    this.$nextTick(() => {
      this.initMap()
    })
  },
  beforeDestroy() {
    if (this.mapInstance) {
      console.log('地图已销毁')
      this.mapInstance.destroy();
    }
  },
  methods: {
    // getLoaction() { // 微信获取定位
    //   return new Promise((resolve) => {
    //     wx.ready(() => {
    //       wx.getLocation({
    //         type: "wgs84",
    //         success: function (res) {
    //           resolve(res)
    //         }
    //       })
    //     })
    //   })
    // },
    searchEvent() {
      if (!this.search) return this.$toast('请输入客户位置')
      getlatandlngbyaddress({ address: this.search }).then(res => {
        if (res.data.length) {
          const data = res.data[0]
          const location = data.location.split(',')
          this.getCityCode(location)
          // this.search = data.formatted_address
          // this.geocoder.getAddress([location], (status, result) => {
          //   if (status === 'complete' && result.regeocodes[0]) {
          //     this.address = result.regeocodes[0].formattedAddress
          //     this.marker.setMap(this.mapRef)
          //     this.infoWindow.setMap(this.mapRef)
          //     this.marker.setPosition(location)
          //     this.infoWindow.setPosition(location)
          //     this.infoWindow.setContent(`<div>您选择的地址是：<br><span style="color: red">${data.formatted_address}</span></div>`)
          //     this.infoWindow.open(this.mapRef, this.marker.getPosition())
          //     this.mapRef.setZoom(18)
          //     this.mapRef.setCenter(this.marker.getPosition())
          //   } else {
          //     this.$toast('获取地址失败')
          //   }
          // })
        } else {
          this.$toast('未查询到你所输入的地址')
        }
      })
    },
    getCustomerList(params) {
      // 获取附近客户列表
      getNearList(params).then((res) => {
        if (res.errcode === 0) {
          this.customerList = res.data;
          this.totalCount = res.page.totalCount
          this.totalPage = res.page.totalPage
        }
      })
    },
    initMap() { // 地图初始化
      if (this.mapInstance) { // 如果地图实例已经存在，先销毁实例
        this.mapInstance.destroy();
      }
      loadMap().then((AMap) => {
        this.mapInstance = new AMap.Map('map', {
          resizeEnable: true, // 是否监控地图容器尺寸变化
          zoom: 16, // 初始化地图层级
          zooms: [11, 19]
        })
        this.mapInstance.on('complete', () => {
          this.initMapUI()
        })
        AMap.plugin(['AMap.Geocoder', 'AMap.Geolocation'], () => {
          this.geocoder = new AMap.Geocoder()
          this.geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 5000, //超过10秒后停止定位，默认：5s
            buttonPosition:'RB', //定位按钮的停靠位置
            buttonOffset: new AMap.Pixel(20, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            zoomToAccuracy: true //定位成功后是否自动调整地图视
          })
          this.mapInstance.addControl(this.geolocation)
          this.geolocation.getCurrentPosition((status, res) => {
            if (status === 'complete' && res.position) {
              const { lat, lng } = res.position
              this.getCityCode([lng, lat])
            } else {
              this.$toast.fail(`定位失败，${res.message}`)
            }
          })
        })
      })
        .catch((err) => {
          console.log(err, '加载失败')
        })
    },
    initMapUI() { // 初始化地图UI
      window.AMapUI.loadUI(['misc/PoiPicker'], (PoiPicker) => {
        const poiPicker = new PoiPicker({
          input: 'pickerInput'
        })
        this.poiPickerReady(poiPicker)
      })
    },
    poiPickerReady(poiPicker) { // 搜索地址
      const { AMap } = window;
      const marker = new AMap.Marker()
      poiPicker.on('poiPicked', (res) => {
        const poi = res.item;
        this.search = res.item.name || ''
        marker.setMap(this.mapInstance);
        marker.setPosition(poi.location);
        this.mapInstance.setCenter(marker.getPosition());
        this.query = {
          ...this.query,
          citycode: poi.adcode,
          lat: `${poi.location.lat}`,
          lng: `${poi.location.lng}`
        }
      })
    },
    getCityCode(center) {
      // 获取城市编码
      this.geocoder.getAddress(center, (status, res) => {
        if (status === 'complete' && res.regeocode) {
          const { adcode } = res.regeocode.addressComponent
          this.query = {
            ...this.query,
            citycode: adcode,
            lat: `${center[1]}`,
            lng: `${center[0]}`
          }
        } else {
          this.$toast.fail('获取行政机构编码失败')
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.customer-location { height: 100vh;
  .customer-list {
    height: calc(~'100% - 360px');
    margin-top: 5px;
    background-color: #fff;
    .no-customer { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #969799; }
    .list { height: calc(~'100% - 45px'); overflow: auto; }
    .page { background: #fff; }
    p {
      display: flex;
      padding: 10px 15px;
      justify-content: space-between;
      span {
        font-size: 14px;
        color: #333;
        i { font-style: normal;
          &:first-of-type { margin-right: 10px; }
        }
        &:last-of-type {
          color: #969799;
        }
      }
    }
  }
  .container {
    .van-cell { overflow: unset;
    }
    .searchClass{
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #FFFFFF;
    }
  }
  #map { height: 300px; }
}
</style>